module.exports = __webpack_public_path__ + "img/in-route.74498171.svg";